import noodleApiClient from '@/tsClient/servers/noodleApi';

type ConflictSource = {
  sourceCategory: string;
  sourceId: string | null;
  value: unknown;
  createdAt: string;
};

type ConflictDetail = {
  fieldPath: string;
  currentValue: unknown;
  sources: ConflictSource[];
  hasPendingReview: boolean;
};

type CaseDataConflictsResponse = {
  caseId: string;
  conflicts: ConflictDetail[];
};

type Input = {
  caseId: string;
};

const getCaseDataConflicts = async ({ caseId }: Input): Promise<CaseDataConflictsResponse> => {
  const response = await noodleApiClient.get(`/cases/${caseId}/conflicts/details`);
  return response.data as CaseDataConflictsResponse;
};

export type { ConflictDetail, ConflictSource, CaseDataConflictsResponse };
export default getCaseDataConflicts;
